import {Box} from '@chakra-ui/react'
import {ComponentType} from 'react'
import {useFormContext} from 'react-hook-form'
import {INPOST_CARRIER} from 'modules/checkout'
import {CartAddressInput} from '_app/types/api'
import {ShowroomsSelect} from '_app/components/shared/ShowroomsSelect'
import {InpostSelect} from '_app/components/shared/InpostSelect'

interface Props {
    show: boolean;
    carrierCode: string;
    onAddressChange: (address: Partial<CartAddressInput>) => void;
}

const Wrapper = (Component: ComponentType<Props>) =>
    function Child(props: Props) {
        return (
            <Box mt={4} display={props.show ? 'block' : 'none'}>
                <Component {...props} />
            </Box>
        )
    }

const PickupMethodDetailsChild = ({carrierCode, onAddressChange}: Props) => {
    const {setValue} = useFormContext()

    switch (carrierCode) {
        case 'pickup': {
            return <ShowroomsSelect onChange={onAddressChange}/>
        }
        case INPOST_CARRIER: {
            return (
                <InpostSelect
                    onChange={onAddressChange}
                    onPointNameChange={val => {
                        setValue('inpost_point', val, {shouldValidate: true})
                    }}
                />
            )
        }
        default: {
            throw new Error('Pickup method not handled')
        }
    }
}

export const PickupMethodDetails = Wrapper(PickupMethodDetailsChild)
